"use client";
import { L } from "@/libs/localization/i18n";
import { useWorkspace } from "../workspace";

export function Footer() {
  const { t, l } = useWorkspace();
  return (
    <footer className="app-footer pt-2.5 px-7.5 pb-5.5 flex justify-between gap-3.75 text-[9px] text-[#8693a5] max-[760px]:py-3.75 max-[760px]:px-4.25 max-[760px]:text-[8px] max-[450px]:[&_>_span:last-child]:hidden">
      <span>{t("demo")}</span>
      <span>
        Baken ·{" "}
        {l(
          L("Meer mens, minder administratie.", "More people, less paperwork."),
        )}
      </span>
    </footer>
  );
}
